/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
} from "../../runtime/index.jsx";
export function Componente_G1_71_49(e) {
  return (
    <li
      key={e.usuarioId}
      className={`flex items-center justify-between gap-2 p-3 text-sm`}
      children={[
        <span
          className={`min-w-0 truncate font-medium text-(--text-h)`}
          children={e.nombre}
        />,
        <span
          className={`shrink-0 text-xs text-(--text)`}
          children={[
            `✅ `,
            e.terminadas,
            ` · ⏸️ `,
            e.abandonadas,
            ` inconclusa`,
            e.abandonadas === 1 ? `` : `s`,
            e.abandonadas ? ` (llega al ${e.progresoPromedioAlDejar}%)` : ``,
          ]}
        />,
      ]}
    />
  );
}
